import { toast } from 'react-toastify';
import SelectInput from '../../Misc/SelectInput/SelectInput.jsx';

const DefeitoModal = ({
    show,
    onClose,
    defeitos,
    setDefeitos,
    opcoesDefeito,
    opcoesLocalizacao,
    opcoesTamanho,
    customSelectStyles,
    mainLancamentoRowData,
    analisesPeca,
    setAnalisesPeca,
    setDefeitosGrid,
    setMainLancamentoRowData,
    campoFotos,
    setLoadingModal,
    registrarAnalisePecaComDefeitos,
    getModalTonalidadeTipo,
    setModalTonalidadeTipo,
    setShowTonalidadeModal,
    styles
}) => {
    if (!show) return null;

    const handleFileChange = (idx, e) => {
        const novos = [...defeitos];
        novos[idx].file = e.target.files[0] || null;
        setDefeitos(novos);
        if (e.target.files[0]) {
            toast.success('Imagem incluída com sucesso!');
        }
    };

    const handleDefeitoChange = (idx, opt) => {
        const novos = [...defeitos];
        novos[idx].defeito = opt ? opt.value : '';
        setDefeitos(novos);
    };

    const handleLocalizacaoChange = (idx, opt) => {
        const novos = [...defeitos];
        novos[idx].localizacao = opt ? opt.value : '';
        setDefeitos(novos);
    };

    const handleTamanhoChange = (idx, opt) => {
        const novos = [...defeitos];
        if (opt) {
            novos[idx].tamanho = opt.value;
            // Salva também a pontuação correspondente
            const tamanhoObj = opcoesTamanho.find(t => String(t.idTamanho) === String(opt.value));
            novos[idx].pontuacao = tamanhoObj ? tamanhoObj.pontuacao : '';
        } else {
            novos[idx].tamanho = '';
            novos[idx].pontuacao = '';
        }
        setDefeitos(novos);
    };

    const handleConsideracaoChange = (idx, value) => {
        const novos = [...defeitos];
        novos[idx].consideracao = value.toUpperCase();
        setDefeitos(novos);
    };

    const handleCondenarChange = (checked) => {
        const novos = [...defeitos];
        novos[0].condenar = checked;
        setDefeitos(novos);
    };

    const handleCloseOrRemove = (idx) => {
        if (idx === 0) {
            onClose();
        } else {
            setDefeitos(prev => prev.filter((_, i) => i !== idx));
        }
    };

    const handleAddDefect = (e) => {
        e.preventDefault();
        setDefeitos(prev => [
            ...prev,
            {
                defeito: '',
                localizacao: '',
                tamanho: '',
                consideracao: '',
                condenar: false
            }
        ]);
    };

    const handleFinishDefects = async (e) => {
        e.preventDefault();
        onClose();
        
        if (mainLancamentoRowData) {
            const id = mainLancamentoRowData.idMpTriangulacaoRev;
            const lote = mainLancamentoRowData.lote;
            const qtdePecas = mainLancamentoRowData.LotesPecas
                ? mainLancamentoRowData.LotesPecas.length
                : 0;
            
            const modalTipo = await getModalTonalidadeTipo(id, lote, qtdePecas);
            
            if (Array.isArray(modalTipo)) {
                // Sempre abre o modal 2 e depois o 3
                const abrirModalSequencia = async tipos => {
                    for (const tipo of tipos) {
                        if (tipo === 2) {
                            setModalTonalidadeTipo('segunda');
                            setShowTonalidadeModal(true);
                            // Aguarda o usuário finalizar o modal antes de abrir o próximo
                            await new Promise(resolve => {
                                const handler = () => {
                                    setShowTonalidadeModal(false);
                                    resolve();
                                };
                                // Supondo que finalizarTonalidadeModal chama handler
                                window._finalizarTonalidadeModalHandler = handler;
                            });
                        } else if (tipo === 3) {
                            setModalTonalidadeTipo('última');
                            setShowTonalidadeModal(true);
                            await new Promise(resolve => {
                                const handler = () => {
                                    setShowTonalidadeModal(false);
                                    resolve();
                                };
                                window._finalizarTonalidadeModalHandler = handler;
                            });
                        }
                    }
                };
                abrirModalSequencia(modalTipo);
                return;
            } else {
                // Definição das variáveis de quantidade de peças
                const qtdePecasParaAnaliseDoPedido = mainLancamentoRowData?.qtdePecas || 0;
                const qtdeTotalPecasAnalisadasPedido = analisesPeca?.length || 0;
                
                if (modalTipo === 1) {
                    setModalTonalidadeTipo('primeira');
                    setShowTonalidadeModal(true);
                    return;
                } else if (modalTipo === 2) {
                    setModalTonalidadeTipo('segunda');
                    setShowTonalidadeModal(true);
                    return;
                } else if (modalTipo === 3) {
                    setModalTonalidadeTipo('última');
                    setShowTonalidadeModal(true);
                    return;
                }
                
                // Verificação extra: se faltar apenas uma peça para análise no pedido, abrir modal 3
                if (
                    qtdePecasParaAnaliseDoPedido > 0 &&
                    qtdeTotalPecasAnalisadasPedido === qtdePecasParaAnaliseDoPedido - 1
                ) {
                    setModalTonalidadeTipo('última');
                    setShowTonalidadeModal(true);
                    return;
                }
            }
        }
        
        // SUB-MODAL: Envia análise peça + defeitos (agora incluindo imagens dos defeitos)
        if (typeof registrarAnalisePecaComDefeitos === 'function' && mainLancamentoRowData) {
            const parseFloatOrNull = v => {
                if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                const n = parseFloat(String(v).replace(',', '.'));
                return isNaN(n) ? null : n;
            };
            
            // Monta analisePeca
            const analisePeca = {
                idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                pedido: mainLancamentoRowData.pedido,
                lote: parseFloatOrNull(mainLancamentoRowData.lote),
                peca: parseFloatOrNull(mainLancamentoRowData.peca),
                larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(
                    item => item.lote == mainLancamentoRowData.lote
                )?.idMpTriangulacaoRevLotesPecas,
                pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
            };
            
            // Monta o array de defeitos, incluindo nome da imagem
            const defeitosPayload = defeitos.map((defeito, idx) => ({
                idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                idTipoDefeito: defeito.defeito,
                idLocalizacaoDefeito: defeito.localizacao,
                idTamanhoDefeito: defeito.tamanho,
                pontuacao: defeito.pontuacao,
                consideracaoDefeito: defeito.consideracao || '',
                imagemDefeito: defeito.file
                    ? `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`
                    : null
            }));
            
            const payload = {
                condenarPeca: defeitos[0]?.condenar ? 1 : 0,
                analisePeca,
                defeitos: defeitosPayload
            };
            
            const formData = new FormData();
            formData.append('jsonBody', JSON.stringify(payload));
            
            // Adiciona imagens dos defeitos
            defeitos.forEach((defeito, idx) => {
                if (defeito.file) {
                    const nomeArquivo = `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`;
                    formData.append('imagensDefeitos', defeito.file, nomeArquivo);
                }
            });
            
            // Adiciona imagens dos campos principais (usar arquivos por peça)
            ['larguraFornecedor', 'larguraMeio', 'metragemFornecedor', 'relogio'].forEach(campo => {
                const fileObj = campoFotos?.[mainLancamentoRowData?.peca]?.[campo];
                if (fileObj && fileObj.file) {
                    const nomeArquivo = {
                        larguraFornecedor: 'imagemLarguraFornecedor',
                        larguraMeio: 'imagemLarguraMeio',
                        metragemFornecedor: 'imagemMetragemFornecedor',
                        relogio: 'imagemRelogio'
                    }[campo];
                    const ext = fileObj.file.name
                        .substring(fileObj.file.name.lastIndexOf('.'))
                        .toLowerCase();
                    if (ext === '.jpg' || ext === '.jpeg') {
                        formData.append('files', fileObj.file, `${nomeArquivo}${ext}`);
                    } else {
                        toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                    }
                }
            });
            
            setLoadingModal(true);
            const response = await registrarAnalisePecaComDefeitos(formData, true); // true = multipart
            
            if (response) {
                // Atualiza o grid de análise de peça (bloco 4)
                if (response.analisePeca) {
                    setAnalisesPeca(prev => [...prev, response.analisePeca]);
                }
                // Atualiza o grid de defeitos (bloco 5)
                if (Array.isArray(response.defeitos)) {
                    setDefeitosGrid(response.defeitos);
                }
                setLoadingModal(false);
                setDefeitos([{
                    defeito: '',
                    localizacao: '',
                    tamanho: '',
                    consideracao: '',
                    condenar: false
                }]);
                setMainLancamentoRowData(prev =>
                    prev ? {
                        ...prev,
                        lote: '',
                        peca: '',
                        larguraFornecedor: '',
                        larguraInicio: '',
                        larguraMeio: '',
                        larguraFim: '',
                        ourela: '',
                        metragemFornecedor: '',
                        relogio: '',
                        nomePeca: ''
                    } : null
                );

                setDefeitos([{
                    defeito: '',
                    localizacao: '',
                    tamanho: '',
                    consideracao: '',
                    condenar: false,
                    file: null
                }]);
            }
        }
    };

    const getDefeitoValue = (defeito) => {
        if (!defeito.defeito) return null;
        const found = opcoesDefeito.find(opt => String(opt.idDefeito) === String(defeito.defeito));
        return found ? { value: found.idDefeito, label: found.nomeDefeito || '' } : null;
    };

    const getLocalizacaoValue = (defeito) => {
        if (!defeito.localizacao) return null;
        return opcoesLocalizacao
            .filter(opt => String(opt.idLoc) === String(defeito.localizacao))
            .map(opt => ({ value: opt.idLoc, label: opt.nomeLocDef }))[0] || null;
    };

    const getTamanhoValue = (defeito) => {
        if (!defeito.tamanho) return null;
        return opcoesTamanho
            .filter(opt => String(opt.idTamanho) === String(defeito.tamanho))
            .map(opt => ({ value: opt.idTamanho, label: `De ${opt.minimo} a ${opt.maximo} (Pontuação: ${opt.pontuacao})` }))[0] || null;
    };

    return (
        <div className={styles.modalOverlayDefeitos}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                overflowY: 'auto',
                overflowX: 'hidden',
                maxHeight: '80vh',
                alignItems: 'center',
            }}>
                {/* Renderiza todos os modais de defeito (principal e extras) */}
                {defeitos.map((defeito, idx) => (
                    <div key={idx} className={styles.defeitoSubModalBox} style={{ minWidth: 900, maxWidth: 980, width: 900, flex: '0 0 auto', position: 'relative', marginTop: 0 }}>
                        {/* Botão de fechar/remover este bloco extra OU fechar o sub-modal (sempre mostra o X no topo direito) */}
                        <button
                            className={styles.modalCloseBtn}
                            style={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
                            onClick={() => handleCloseOrRemove(idx)}
                            aria-label={idx === 0 ? "Fechar" : "Remover este defeito"}
                            type="button"
                        >
                            ×
                        </button>
                        
                        {/* Título do sub-modal */}
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
                            <div className={styles.defeitoSubModalTitleBox}>
                                <span className={styles.defeitoSubModalTitle}>INCLUSÃO DE DEFEITO</span>
                            </div>
                        </div>
                        
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
                            <input
                                id={`fileInput_defeito_${idx}`}
                                type="file"
                                accept=".jpg,.jpeg,image/jpg,image/jpeg"
                                style={{ display: 'none' }}
                                onChange={e => handleFileChange(idx, e)}
                            />
                            <button
                                type="button"
                                className={styles.cameraButton}
                                onClick={() => document.getElementById(`fileInput_defeito_${idx}`).click()}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    filter: defeito.file ? 'invert(41%) sepia(98%) saturate(749%) hue-rotate(85deg) brightness(95%) contrast(92%)' : 'none'
                                }}
                            >
                                <img src="/img/camera_icon.png" alt="Anexar foto do defeito" style={{ width: 28, height: 28 }} />
                            </button>
                            <span style={{
                                marginLeft: 12,
                                alignSelf: 'center',
                                fontWeight: 500,
                                color: '#202D3B',
                                fontSize: '1rem',
                                filter: defeito.file ? 'invert(41%) sepia(98%) saturate(749%) hue-rotate(85deg) brightness(95%) contrast(92%)' : 'none'
                            }}>
                                {defeito.file ? 'foto incluída!' : 'Inclua uma Foto *'}
                            </span>
                        </div>
                        
                        {/* Comboboxes para Defeito, Localização e Tamanho */}
                        <div className={styles.defeitoSubModalSelectRow}>
                            <div className={styles.defeitoSubModalSelectCol}>
                                <div className={styles.lancamentoHeaderLabel} style={{ background: 'none', color: '#000', boxShadow: 'none', textShadow: 'none' }}>DEFEITO *</div>
                                <SelectInput
                                    placeholder={'Selecione'}
                                    isSearchable={false}
                                    label={null}
                                    options={opcoesDefeito.map(opt => ({ value: opt.idDefeito, label: opt.nomeDefeito }))}
                                    value={getDefeitoValue(defeito)}
                                    onChange={opt => handleDefeitoChange(idx, opt)}
                                    className={styles.lancamentoHeaderValue}
                                    customSelectStyles={customSelectStyles}
                                    isClearable={true}
                                    style={{ width: 'auto' }}
                                />
                            </div>
                            <div className={styles.defeitoSubModalSelectCol}>
                                <div className={styles.lancamentoHeaderLabel} style={{ background: 'none', color: '#000', boxShadow: 'none', textShadow: 'none' }}>LOCALIZAÇÃO *</div>
                                <SelectInput
                                    placeholder={'Selecione'}
                                    isSearchable={false}
                                    label={null}
                                    options={opcoesLocalizacao.map(opt => ({ value: opt.idLoc, label: opt.nomeLocDef }))}
                                    value={getLocalizacaoValue(defeito)}
                                    onChange={opt => handleLocalizacaoChange(idx, opt)}
                                    className={styles.lancamentoHeaderValue}
                                    customSelectStyles={customSelectStyles}
                                    isClearable={true}
                                    style={{ width: 'auto' }}
                                />
                            </div>
                            <div className={styles.defeitoSubModalSelectCol}>
                                <div className={styles.lancamentoHeaderLabel} style={{ background: 'none', color: '#000', boxShadow: 'none', textShadow: 'none' }}>TAMANHO *</div>
                                <SelectInput
                                    placeholder={'Selecione'}
                                    isSearchable={false}
                                    label={null}
                                    options={opcoesTamanho.map(opt => ({ value: opt.idTamanho, label: `De ${opt.minimo} a ${opt.maximo} (Pontuação: ${opt.pontuacao})` }))}
                                    value={getTamanhoValue(defeito)}
                                    onChange={opt => handleTamanhoChange(idx, opt)}
                                    className={styles.lancamentoHeaderValue}
                                    customSelectStyles={customSelectStyles}
                                    isClearable={true}
                                    style={{ width: 'auto' }}
                                />
                            </div>
                        </div>
                        
                        {/* Campo Consideração e checkbox Condenar peça (apenas no primeiro modal) */}
                        <div className={styles.defeitoSubModalInputs}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', marginLeft: 6 }}>
                                <div className={styles.loteInputConsideration}>
                                    <div>CONSIDERAÇÃO:</div>
                                    <input
                                        type="text"
                                        className={styles.lancamentoHeaderValue}
                                        placeholder="Digite a consideração"
                                        value={defeito.consideracao}
                                        style={{ color: 'red', textTransform: 'uppercase', fontWeight: '600', height: '33px', fontSize: '1rem', width: '100%', marginLeft: -20 }}
                                        onChange={e => handleConsideracaoChange(idx, e.target.value)}
                                    />
                                </div>
                                {/* Checkbox Condenar peça só no primeiro modal */}
                                {idx === 0 && (
                                    <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', marginLeft: 80 }}>
                                        <input
                                            type="checkbox"
                                            id="condenarPeca"
                                            checked={defeito.condenar}
                                            onChange={e => handleCondenarChange(e.target.checked)}
                                            style={{ marginRight: 10 }}
                                        />
                                        <label htmlFor="condenarPeca" style={{ fontWeight: '600', fontSize: '1rem', color: '#0a0909', marginTop: -3 }}>Condenar peça</label>
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        {/* Botões de ação do sub-modal (apenas no último modal) */}
                        {idx === defeitos.length - 1 && (
                            <div
                                className={styles.defeitoSubModalBtnRow}
                                style={{ flexDirection: 'column', alignItems: 'center', gap: 8 }}
                            >
                                <span
                                    style={{
                                        fontWeight: 500,
                                        fontSize: '1.05rem',
                                        color: '#202D3B',
                                        marginBottom: 6
                                    }}
                                >
                                    Deseja incluir mais defeitos?
                                </span>
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: 16,
                                        justifyContent: 'center',
                                        width: '100%'
                                    }}
                                >
                                    <button
                                        className={
                                            `${styles.btnNao} ${!(
                                                defeito.file &&
                                                defeito.defeito &&
                                                defeito.localizacao &&
                                                defeito.tamanho
                                            ) ? styles.btnNaoDisabled : ''}`
                                        }
                                        style={{
                                            padding: '4px 16px',
                                            fontSize: '0.98rem',
                                            minWidth: 60,
                                            minHeight: 30,
                                            border: 'none'
                                        }}
                                        onClick={handleFinishDefects}
                                        disabled={
                                            !(
                                                defeito.file &&
                                                defeito.defeito &&
                                                defeito.localizacao &&
                                                defeito.tamanho
                                            )
                                        }
                                    >
                                        NÃO
                                    </button>
                                    <button
                                        className={styles.btnSim}
                                        style={{
                                            padding: '4px 16px',
                                            fontSize: '0.98rem',
                                            minWidth: 60,
                                            minHeight: 30
                                        }}
                                        onClick={handleAddDefect}
                                    >
                                        SIM
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DefeitoModal;